import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

ImpactCard.propTypes = {
  title: PropTypes.node,
  body: PropTypes.node,
  // Tailwind background + text color classes for the card's color scheme.
  bg: PropTypes.string,
  textColor: PropTypes.string
};

export default function ImpactCard(props) {
  const { title, body, bg, textColor } = props;

  return (
    <div className={classNames('rounded-cs-10 p-6 flex flex-col gap-3 shadow-lg', bg)}>
      <h3 className={classNames('text-2xl font-semibold leading-tight', textColor)}>{title}</h3>
      <p className={classNames('text-sm leading-snug', textColor)}>{body}</p>
    </div>
  );
}
